var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { lazy, Suspense, useEffect } from 'react';
// import './mixins/grid.scss';
// import './mixins/spacing.css';
// import './mixins/fonts.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './KodanshaApp.scss';
import './Reboot.scss';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useAtom, useAtomValue } from 'jotai';
import { AccessTokenAtom, AccountInfoAtom, LoginStatusAtom } from '../store/AccountStore';
import { CheckoutOverlayVisible, LoginOverlayVisible } from '../store/OverlayStore';
import { PaymentIntentAtom, PaymentMethodAtom, ShowPaymentProcessingOverlayAtom } from '../store/PaymentStore';
import { CartIdAtom, GetAddToCartOverlayBox } from '../store/CartStore';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { useLocalStorage } from './Services/localstorage/useLocalStorage';
import { LocalStorageKeys } from './Services/localstorage/LocalStorageKeys';
import ReactGA from 'react-ga4';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../store/AnalyticsStore';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { Md5 } from 'ts-md5';
import apiClient from '../API/InkyAPI';
import AnalyticsEvent from '../Models/Analytics/AnalyticsEvent';
import { Helmet } from 'react-helmet';
import SDCC from './SDCC';
import Log from './Services/Logger';
import { UseStripeWrapperAtom } from '../store/LoadStripeStore';
import { GTagManager, GTagManagerTriggerLoad } from '../Devon/Components/GTagManager/GTagManager';
import MAL from './MAL';
import { attachDebugMode } from '../store/DebugStore';
// React-components (Remember to lazy-load)
var Account = lazy(function () { return import('./Routes/Account/Account'); });
// Lazy-loaded components
var KodanshaNews = lazy(function () { return import('./KodanshaNews').then(function (module) { return ({ default: module.KodanshaNews }); }); });
var KodanshaArticle = lazy(function () { return import('./KodanshaArticle').then(function (module) { return ({ default: module.KodanshaArticle }); }); });
var KodanshaCheckout = lazy(function () { return import('./KodanshaCheckout').then(function (module) { return ({ default: module.KodanshaCheckout }); }); });
var KodanshaReader = lazy(function () { return import('./KodanshaReader').then(function (module) { return ({ default: module.KodanshaReader }); }); });
var KodanshaHome = lazy(function () { return import('./KodanshaHome').then(function (module) { return ({ default: module.KodanshaHome }); }); });
var Dashboard = lazy(function () { return import('../Components/Dashboard/Dashboard'); });
var KodanshaSeries = lazy(function () { return import('./Routes/Series/KodanshaSeries'); });
var KodanshaAuth = lazy(function () { return import('./KodanshaAuth/KodanshaAuth'); });
var KodanshaLibrary = lazy(function () { return import('./KodanshaLibrary').then(function (module) { return ({ default: module.KodanshaLibrary }); }); });
var KodanshaProduct = lazy(function () { return import('./Routes/Product/KodanshaProduct'); });
var KodanshaBrowse = lazy(function () { return import('./KodanshaBrowse').then(function (module) { return ({ default: module.KodanshaBrowse }); }); });
var KodanshaSearch = lazy(function () { return import('./KodanshaSearch'); });
var KodanshaCheckoutSuccess = lazy(function () { return import('./KodanshaCheckoutSuccess/KodanshaCheckoutSuccess'); });
var KodanshaDiscover = lazy(function () { return import('./KodanshaDiscover').then(function (module) { return ({ default: module.KodanshaDiscover }); }); });
var KodanshaReleaseCalendar = lazy(function () { return import('./KodanshaReleaseCalendar').then(function (module) { return ({ default: module.KodanshaReleaseCalendar }); }); });
var CookiesConsent = lazy(function () { return import('./CookiesConsent/CookiesConsent'); });
var AnimeExpo = lazy(function () { return import('./AX'); });
var AccountBenefits = lazy(function () { return import('./StaticPages/AccountBenefits').then(function (module) { return ({ default: module.AccountBenefits }); }); });
var KodanshaAbout = lazy(function () { return import('./KodanshaAbout/KodanshaAbout').then(function (module) { return ({ default: module.KodanshaAbout }); }); });
var SupportCenter = lazy(function () { return import('./SupportCenter/SupportCenter').then(function (module) { return ({ default: module.SupportCenter }); }); });
var AddedToCartOverlay = lazy(function () { return import('./KodanshaAddedToCartOverlay/AddedToCartOverlay').then(function (module) { return ({ default: module.AddedToCartOverlay }); }); });
var TermsOfUse = lazy(function () { return import('./StaticPages/TermsOfUse').then(function (module) { return ({ default: module.TermsOfUse }); }); });
var PrivacyPolicy = lazy(function () { return import('./StaticPages/PrivacyPolicy').then(function (module) { return ({ default: module.PrivacyPolicy }); }); });
var Copyright = lazy(function () { return import('./StaticPages/Copyright'); });
var KodanshaLibrarians = lazy(function () { return import('./StaticPages/Librarians').then(function (module) { return ({ default: module.Librarians }); }); });
export function KodanshaApp(props) {
    var renderLoading = function () { return _jsx(_Fragment, { children: " " }); };
    /**
     * All overlays except Login + Force mount necessary atoms.
     * @constructor
     */
    function Overlays() {
        var _a = __read(useAtom(CheckoutOverlayVisible), 1), checkoutOverlay = _a[0];
        var _b = __read(useAtom(GetAddToCartOverlayBox), 1), addToCartOverlay = _b[0];
        //The following need to be referenced so that we can trigger an onMount.
        var _c = __read(useAtom(AccessTokenAtom), 1), AccessToken = _c[0];
        var _d = __read(useAtom(CartIdAtom), 1), CartId = _d[0];
        //For the payment overlays (TODO: Check if these are truly necessary)
        var _e = __read(useAtom(PaymentIntentAtom), 1), paymentIntent = _e[0];
        var _f = __read(useAtom(PaymentMethodAtom), 1), paymentMethod = _f[0];
        var _g = __read(useAtom(ShowPaymentProcessingOverlayAtom), 1), showPaymentProcessingOverlay = _g[0];
        Log.debug("Render overlays...");
        return (_jsxs(React.Fragment, { children: [addToCartOverlay === true && _jsx(Suspense, { fallback: renderLoading(), children: _jsx(AddedToCartOverlay, {}) }), checkoutOverlay && _jsx(Suspense, { fallback: renderLoading(), children: _jsx(KodanshaCheckout, {}) })] }));
    }
    /**
     * Login overlay only. Leave this outside the stripe wrapper or it breaks the login.
     * @constructor
     */
    function LoginOverlay() {
        var loginOverlay = useAtomValue(LoginOverlayVisible);
        if (loginOverlay) {
            return (_jsx(Suspense, { fallback: renderLoading(), children: _jsx(KodanshaAuth, {}) }));
        }
        return null;
    }
    function CookiesAndConsent() {
        var _a = __read(useLocalStorage(LocalStorageKeys.CookiesConsent.toString(), false), 2), CookiesConsentValue = _a[0], setCookiesConsentValue = _a[1];
        return CookiesConsentValue ? null : (_jsx(Suspense, { fallback: renderLoading(), children: _jsx(CookiesConsent, { setCookiesConsentValue: setCookiesConsentValue }) }));
    }
    function AccountInfo() {
        var _a = __read(useAtom(AccountInfoAtom), 2), accountInfo = _a[0], setAccountInfo = _a[1];
        var updateVerification = function (event) {
            if (event.key === 'email_verified') {
                var accountInfoTemp = __assign(__assign({}, accountInfo), { verified: true });
                setAccountInfo(accountInfoTemp);
                window.removeEventListener('storage', updateVerification);
                localStorage.removeItem('email_verified');
            }
        };
        useEffect(function () {
            window.addEventListener('storage', updateVerification);
            return function () {
                window.removeEventListener('storage', updateVerification);
            };
        }, [accountInfo]);
        Log.debug("Render Account Info...");
        return null;
    }
    //ToDO: Since there is no UI logic here, Could this be turned into an atom?
    function Analytics() {
        var _a = __read(useAtom(AnalyticsIdAtom), 2), analyticsId = _a[0], setAnalyticsId = _a[1];
        var _b = __read(useAtom(AnalyticsUserProxyAtom), 2), analyticsUserProxy = _b[0], setAnalyticsUserProxy = _b[1];
        var googleAnalyticsID = process.env.GA_TRACKING_ID;
        var location = useLocation();
        var _c = __read(useAtom(AccountInfoAtom), 1), accountInfo = _c[0];
        var _d = __read(useAtom(LoginStatusAtom), 1), loginStatus = _d[0];
        function generateSessionId() {
            var randomId = uuidv4();
            var time = dayjs(Date.now()).unix(); // 1548381600
            var hash = Md5.hashStr(randomId.toString() + time.toString());
            return hash;
        }
        if (navigator.userAgent !== 'RenderBot') {
            // react-ga4 apparently have no way to defer,
            // so we are explicitly holding the initialization back.
            var timer = setTimeout(function () {
                Log.info("Loading GA");
                // Do something if the user agent is not RenderBot
                ReactGA.initialize(googleAnalyticsID);
            }, 2000);
        }
        function sendEvent() {
            if (navigator.userAgent !== 'RenderBot') {
                apiClient.sendEvent(accountInfo, new AnalyticsEvent(analyticsId.toString(), 'PAGE_VIEW', location.pathname, window.location.href, analyticsUserProxy.toString())).then(function (res) {
                    //console.log(res.data);
                });
            }
        }
        useEffect(function () {
            Log.debug('ANALYTICS SESSION:', analyticsId);
            if (analyticsId === '') {
                Log.debug('Generating Analytics Id.');
                if (sessionStorage.getItem("sessionId") === null)
                    setAnalyticsId(generateSessionId());
            }
        }, [analyticsId]);
        useEffect(function () {
            if (localStorage.getItem("userProxy") === null)
                setAnalyticsUserProxy(generateSessionId());
        }, [analyticsUserProxy]);
        useEffect(function () {
            Log.info('Location changed');
            console.log(accountInfo);
            if (loginStatus === "Unknown")
                return null;
            else if (analyticsId.toString() !== '' && loginStatus.toString() !== "Unknown") {
                sendEvent();
                return null;
            }
        }, [location, analyticsId, loginStatus]);
        return null;
    }
    function useQuery() {
        var search = useLocation().search;
        return React.useMemo(function () { return new URLSearchParams(search); }, [search]);
    }
    /**
     *
     * @constructor
     */
    function MainOrPage() {
        var query = useQuery();
        if (query.has('page_id')) {
            Log.info("Found page_id=".concat(query.get('page_id')));
            return _jsx(KodanshaArticle, { overrideUrl: "%3Fpage_id=".concat(query.get('page_id')) });
            //return <Redirect to={`%3Fpage_id=${query.get('page_id')}`} />;
        }
        if (query.has('p')) {
            Log.info("Found p=".concat(query.get('p')));
            return _jsx(KodanshaArticle, { overrideUrl: "%3Fp=".concat(query.get('p')) });
            // return <Redirect to={`%3Fp=${query.get('p')}`} />;
        }
        return _jsx(KodanshaHome, {});
    }
    Log.info("Render Whole App...");
    useEffect(function () {
        GTagManagerTriggerLoad();
    }, []);
    return (_jsxs(React.Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: 'Kodansha – Inspire Impossible Stories' }) }), _jsx(AccountInfo, {}), _jsx(LoginOverlay, {}), _jsxs(StripeWrapper, { children: [_jsx(Overlays, {}), _jsx(Suspense, { fallback: renderLoading(), children: _jsxs(Switch, { children: [_jsx(Route, { path: '/search', render: function () { return _jsx(KodanshaSearch, {}); } }), _jsx(Route, { path: '/checkout', render: function () { return _jsx(KodanshaHome, { showCheckout: true }); } }), _jsx(Route, { exact: true, path: '/', render: function () { return _jsx(MainOrPage, {}); } }), _jsx(Route, { exact: true, path: '/product/:pid', render: function () { return _jsx(KodanshaProduct, {}); } }), _jsx(Route, { exact: true, path: '/series/:sid', render: function () { return _jsx(KodanshaSeries, {}); } }), _jsx(Route, { exact: true, path: '/news', render: function () { return _jsx(KodanshaNews, {}); } }), _jsx(Route, { exact: true, path: '/news/articles/:aid', render: function () { return _jsx(KodanshaArticle, {}); } }), _jsx(Route, { exact: true, path: '/:year/:month/:day/:aid', render: function () { return _jsx(KodanshaArticle, {}); } }), _jsx(Route, { exact: true, path: '/dashboard*', render: function () { return _jsx(Dashboard, {}); } }), _jsx(Route, { exact: true, path: '/reader/:pid', render: function () { return _jsx(KodanshaReader, {}); } }), _jsx(Route, { exact: true, path: '/library', render: function () { return _jsx(KodanshaLibrary, {}); } }), _jsx(Route, { exact: true, path: '/librarians', render: function () { return _jsx(KodanshaLibrarians, {}); } }), _jsx(Route, { exact: true, path: '/discover/:id', render: function () { return _jsx(KodanshaDiscover, {}); } }), _jsx(Route, { exact: true, path: '/account', render: function () { return _jsx(Account, {}); } }), _jsx(Route, { exact: true, path: '/calendar', render: function () { return _jsx(KodanshaReleaseCalendar, {}); } }), _jsx(Route, { exact: true, path: '/orderSuccess/:paramId', render: function () { return _jsx(KodanshaCheckoutSuccess, { id: '-1' }); } }), _jsx(Route, { exact: true, path: '/browse', render: function () { return _jsx(KodanshaBrowse, {}); } }), _jsx(Route, { exact: true, path: '/browse/:genreId', render: function () { return _jsx(KodanshaBrowse, {}); } }), _jsx(Route, { exact: true, path: '/copyright', render: function () { return _jsx(Copyright, {}); } }), _jsx(Route, { exact: true, path: '/account-benefits', render: function () { return _jsx(AccountBenefits, {}); } }), _jsx(Route, { exact: true, path: '/ax23', render: function () { return _jsx(Redirect, { to: '/2023/06/15/kodansha-usa-anime-expo-2023 ' }); } }), _jsx(Route, { exact: true, path: '/sdcc23-signup', render: function () { return _jsx(SDCC, {}); } }), _jsx(Route, { exact: true, path: '/aot-worldwide-after-party', render: function () { return _jsx(MAL, {}); } }), _jsx(Route, { exact: true, path: '/ax23-announcements', render: function () { return _jsx(Redirect, { to: '/2023/07/01/july-2023-spring-2024-new-licensing-announcement ' }); } }), _jsx(Route, { exact: true, path: '/sdcc23', render: function () { return _jsx(Redirect, { to: '2023/06/08/vinland-saga-creator-makes-u-s-debut-at-comic-con-2023 ' }); } }), _jsx(Route, { exact: true, path: '/ax23-signup', render: function () { return _jsx(AnimeExpo, {}); } }), _jsx(Route, { exact: true, path: '/about', render: function () { return _jsx(KodanshaAbout, {}); } }), _jsx(Route, { exact: true, path: '/support-center', render: function () { return _jsx(SupportCenter, {}); } }), _jsx(Route, { exact: true, path: '/terms-of-use', render: function () { return _jsx(TermsOfUse, {}); } }), _jsx(Route, { exact: true, path: '/privacy-policy', render: function () { return _jsx(PrivacyPolicy, {}); } }), _jsx(Route, { exact: true, path: '/email-verified', render: function () { return _jsx(AccountBenefits, { verifiedLink: true }); } }), _jsx(Route, { path: '/:aid', render: function () { return _jsx(KodanshaArticle, {}); } })] }) }), _jsx(CookiesAndConsent, {})] }), _jsx(Analytics, {}), _jsx(GTagManager, { scriptId: 'gtm-script-container', Id: 'GTM-N4GJK84' })] }));
}
/**
 * Only load Stripe when needed as defined by UseStripeWrapperAtom
 */
function StripeWrapper(props) {
    var useStripeWrapper = useAtomValue(UseStripeWrapperAtom);
    var _a = __read(React.useState(null), 2), stripe = _a[0], setStripe = _a[1];
    React.useEffect(function () {
        if (useStripeWrapper) {
            Log.info('Loading stripe...');
            setStripe(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY));
        }
        else {
            Log.info('No need for stripe yet...');
        }
    }, [useStripeWrapper]);
    Log.info('render StripeWrapper...');
    return _jsx(Elements, { stripe: stripe, children: props.children });
}
attachDebugMode(window);
